import axios from "axios";
import { apiConfigs } from "../../common/configs/apiConfig";

export const axiosInstance = axios.create({
  baseURL: apiConfigs.baseUrl,
  timeout: apiConfigs.timeout,
  headers: {
    "Content-Type": apiConfigs.contentType,
    // "Access-Control-Allow-Origin": "*",
  },
});

export const setAuthToken = (token?: string) => {
  if (token) {
    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axiosInstance.defaults.headers.common["Authorization"];
  }
};

export { axiosInstance as axios };
